import { useActorRef } from '@xstate/react';

import { bundleMachine } from './bundle.machine';
import { type Input } from './types';

import type { MachineImplementationsFrom } from 'xstate';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Initializes and provides a reference to a bundle state machine actor.
 */
export const useInitBundleMachine = (input: Input, implementations: Implementations) => {
  return useActorRef(bundleMachine.provide(implementations), { input });
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Implementations = MachineImplementationsFrom<typeof bundleMachine>;
